import { Box, ClickAwayListener, Paper } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

import { styles } from "./styles";

const NavProjectSelect = ({ handleCloseMenu, items, open }) => {
  return (
    open && (
      <ClickAwayListener onClickAway={handleCloseMenu}>
        <Box sx={styles.selectMenuContainer}>
          <Paper sx={styles.selectMenu}>
            {items.map(([key, value], index) => {
              return (
                <Link
                  key={index}
                  rel={value.EXTERNAL_PATH ? "noopener noreferrer" : ""}
                  style={{ textDecoration: "none" }}
                  target={value.EXTERNAL_PATH ? "_blank" : ""}
                  to={value.EXTERNAL_PATH ? value.EXTERNAL_PATH : value.PATH}
                >
                  <Box sx={styles.selectOption}>{value.LABEL}</Box>
                </Link>
              );
            })}
          </Paper>
        </Box>
      </ClickAwayListener>
    )
  );
};

export default NavProjectSelect;
